import React from "react";
import Contents from "../components/pages/preMatching/en/Contents";
import Header from "../components/header/en/Header";
import Footer from "../components/footer/en/Footer";

const PreMatching = () => {
  return (
    <>
      <Header />
      <Contents />
      <Footer />
    </>
  );
};

export default PreMatching;
